import React, {Component} from "react";
import Api from "../../../../Services/Api";
import {mapToObjectDDL} from "../../../common/mapper";
import SimpleDDL from "../../../../modules/SimpleDDL";
import Container from "../../../../modules/commons/Container";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import FlexView from "react-flexview";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import CRMAssignContent from "./components/crmAssignContent";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {HttpStatus} from "../../../common/Constants";

class CRMAssign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataCabang: [],
            kodeCabang: {},
            submittedFilter: {},
        };
    };

    async componentDidMount() {
        this.handleTriggerLoading();
        await this.fetchDataCabang();
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                    }))
                }
            }
            if (res.data.status === HttpStatus.FAILED) {
                this.props.setError({
                    menuName: "CRM - Assign Prospek",
                    errorMessage: res.data.message,
                });
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    handleSetState = (callback) => {
        this.setState(callback);
    }

    handleChangeKodeCabang = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            kodeCabang: value,
        }))
    }

    render() {
        return (
            <>
                <Container>
                    <FlexView column>
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama Cabang"
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value, {name}) => this.handleChangeKodeCabang(value)}
                        />
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>Belum Assign</Tab>
                            <Tab>Assigned</Tab>
                        </TabList>
                        <TabPanel>
                            <CRMAssignContent
                                {...this.props}
                                tab="belum_assign"
                                onSetState={this.handleSetState}
                                state={this.state}
                                handleLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <CRMAssignContent
                                {...this.props}
                                tab="assigned"
                                onSetState={this.handleSetState}
                                state={this.state}
                                handleLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CRMAssign);
